'use client';

import React from 'react';
import { COMPANY_STATS, GOOGLE_REVIEWS } from '@/lib/company-constants';
import styles from './TrustBadges.module.css';

interface TrustBadgesProps {
  labels: {
    locations: string;
    countries: string;
    orders: string;
    rating: string;
    posIntegrations: string;
  };
  variant?: 'compact' | 'full';
}

export function TrustBadges({ labels, variant = 'compact' }: TrustBadgesProps) {
  const badges = [
    { value: COMPANY_STATS.activeCustomers.value, label: labels.locations },
    { value: COMPANY_STATS.countries.value, label: labels.countries },
    { value: COMPANY_STATS.ordersPerYear.value, label: labels.orders },
    { value: GOOGLE_REVIEWS.ratingString + '/5', label: labels.rating },
    { value: '15+', label: labels.posIntegrations },
  ];

  return (
    <div
      className={`${styles.trustBar} ${variant === 'full' ? styles.full : ''}`}
      data-speakable
      aria-label="Trust indicators"
    >
      {badges.map((badge, i) => (
        <div key={i} className={styles.badge}>
          <span className={styles.badgeValue}>{badge.value}</span>
          <span className={styles.badgeLabel}>{badge.label}</span>
        </div>
      ))}
    </div>
  );
}
